<div [class]="zoneConnection.valid?'container':'error-container'">
  <div class="infoContainer">
    <div class="location-container icon-container">
      <tun-location-icon></tun-location-icon>
    </div>
    @if (!(loadingZoneInfo$ | async)) {
      <div class="zone-container">
        <tun-scrollable-text class="name-label" [text]="nameForView"></tun-scrollable-text>
        @if (zoneConnection.locationName != null) {
          <tun-scrollable-text class="location-label" text="{{zoneConnection.locationName}}"></tun-scrollable-text>
        }
      </div>
    }
    @if (loadingZoneInfo$ | async) {
      <div class="status">
        <tun-loader text="general.loading"></tun-loader>
      </div>
    }
  </div>




  <div class="button-container">

    @if (sharingZoneConnection$ | async) {
      <div class="button button-player-disabled">
        <tun-loader-v5 text="desktopApp.connect.zoneConnection.button.share.busy"></tun-loader-v5>
      </div>
    }

    @if (zoneConnectionShared) {
      <div class="button button-player-disabled" translate>
        desktopApp.connect.zoneConnection.button.share.done
      </div>
    }

    @if (!zoneConnectionShared && !(sharingZoneConnection$ | async)) {
      <button type="submit"
        (click)="shareToDesktopApp()" class="button button-player" translate
        >
        desktopApp.connect.zoneConnection.button.share
      </button>
    }

  </div>

</div>
